// extracted by mini-css-extract-plugin
module.exports = {"date":"PastBlock_date_mtP4-"};